import AdditionalQuotationAmounts from '../domain/AdditionalQuotationAmounts';

export default function getAdditionalQuotationAmounts(quotationItems) {
  return new AdditionalQuotationAmounts().fromFrozenQuotationItems(quotationItems);
}
